module.exports = __webpack_public_path__ + "img/epid-poc.fdf95a07.svg";